// extracted by css-extract-rspack-plugin
export default {"byline":"_dac8530d"};